"use client";
import React from "react";
import PropTypes from "prop-types";
import RedirectionToPLPComponent from "../../../../containers/productDetailPage/productDetailComponents/redirectionToPLPComponent";
import SerenadeProduct from "../../../molecules/serenadeProduct";
import Calendar from "../../../molecules/calendar/calendar";
import ButtonComponent from "../../../atoms/button";
import { COUNTRIES, SELECT_DELIVERY_DATE } from "../../../../constants/common/common";
import PopOver from "../../../atoms/popOver";
import { useSelector } from "react-redux";

/**
 *
 */
const DeliveryDateCalendarPopup = ({
  isMobile,
  isCart,
  hasShowDeliveryDatePopover,
  onHandlePopOverVisibility,
  onDateSelection,
  selectedDate,
  currentItem = {},
  multiOrderDateRange,
  isOutOfStock,
  hasMultiOrderProductChange,
  pinCode,
  msgContent,
  isCutoffTimestamp,
  hasNonDeliverableToast,
  setNonDeliverebleToast,
}) => {
  const { isMultiOrderProduct, multiOrderProductDetails } = currentItem;

  const { deliveryDates, blockedDates } = useSelector((state) => ({
    deliveryDates: state?.shippingDateAndSlotSelection?.deliveryDates,
    blockedDates: state?.shippingDateAndSlotSelection?.blockedDates,
  }));

  return (
    <>
      <PopOver
        classes={`${isMobile || isCart ? "w-[100%] h-[100%] rounded-none" : "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"}`}
        isVisible={hasShowDeliveryDatePopover}
        isBackdrop={true}
        id="multiProduct"
        border={false}
      >
        <div className={`flex w-[100%] flex-col gap-16 ${isMultiOrderProduct ? "md:h-500" : "md:h-auto"} md:w-500`}>
          <div className={`relative flex items-center justify-start gap-16 border-b-1 border-[#F5F5F5] px-5 py-16`}>
            <div className={`flex w-full items-center justify-center`}>
              <div className="top-2 text-16 font-600 text-black-100" data-testid="cart">
                {SELECT_DELIVERY_DATE.toUpperCase()}
              </div>
              {isMobile || isCart ? (
                <div className="cursor-pointer">
                  <ButtonComponent
                    buttonVariant="icon"
                    icon="/icons/left-arrow.svg"
                    // eslint-disable-next-line react/jsx-handler-names
                    onClick={() => onHandlePopOverVisibility()}
                    classes="border-0 absolute top-14 left-16"
                    size="large"
                  />
                </div>
              ) : (
                <div className="cursor-pointer">
                  <ButtonComponent
                    buttonVariant="icon"
                    icon="/icons/close-circle-black.svg"
                    // eslint-disable-next-line react/jsx-handler-names
                    onClick={() => onHandlePopOverVisibility()}
                    classes="border-0 absolute top-12 right-16"
                    size="large"
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className={`custom-scrollbar ${isMultiOrderProduct ? "" : "h-[75vh]"} container  mx-auto overflow-x-hidden px-16 pb-20 md:h-full`}
          >
            <Calendar
              // eslint-disable-next-line react/jsx-handler-names
              onDateSelection={(date) => {
                onDateSelection(date);
              }}
              selectedDate={selectedDate || currentItem?.shippingDetails?.deliveryDate?.fullDeliveryDate}
              isMultiOrderProduct={isMultiOrderProduct}
              multiOrderDateRange={multiOrderDateRange}
            />
            {currentItem?.catalogId === COUNTRIES.INDIA &&
              !isOutOfStock &&
              deliveryDates?.deliveryDates?.length > 0 && (
                <>
                  <RedirectionToPLPComponent
                    blockedDates={blockedDates?.deliveryBlockDates || []}
                    isDisplayCatalogContent={blockedDates?.displayCatalogContent}
                    isCutoffTimestamp={isCutoffTimestamp}
                    isCalender={false}
                    deliveryDatesList={deliveryDates?.deliveryDates}
                    samedayMsgContent={msgContent}
                    limitedCatalogContent={blockedDates?.content}
                    pincode={pinCode}
                    isOutOfStock={isOutOfStock}
                  />
                </>
              )}
          </div>
          {isMultiOrderProduct && (
            <SerenadeProduct
              multiOrderProductChange={hasMultiOrderProductChange}
              isMultiOrderProduct={isMultiOrderProduct}
              nonDeliverableToast={hasNonDeliverableToast}
              multiOrderProductDetails={multiOrderProductDetails}
              setNonDeliverableToast={setNonDeliverebleToast}
              selectedDate={selectedDate}
            />
          )}
        </div>
      </PopOver>
    </>
  );
};

DeliveryDateCalendarPopup.propTypes = {
  isMobile: PropTypes.bool,
  hasShowDeliveryDatePopover: PropTypes.bool,
  isCart: PropTypes.bool,
  onHandlePopOverVisibility: PropTypes.func,
  onDateSelection: PropTypes.func,
  selectedDate: PropTypes.string,
  currentItem: PropTypes.object,
  multiOrderDateRange: PropTypes.array,
  isOutOfStock: PropTypes.bool,
  hasMultiOrderProductChange: PropTypes.bool,
  isCutoffTimestamp: PropTypes.bool,
  pinCode: PropTypes.string,
  msgContent: PropTypes.string,
  hasNonDeliverableToast: PropTypes.bool,
  setNonDeliverebleToast: PropTypes.func,
};

export default DeliveryDateCalendarPopup;
